<template>
  <SeoLandingPage :page="page" />
</template>

<script setup>
import page from "#build/page-data/solutions/creative-agency-project-management-software.mjs";
</script>
